export * from './template.model'; // copy paste and replace me - dont overwrite
